$(document).ready(function () {
  
 
  
  
  
	$("li").click(function () {       
      let selectionSize = $(this).attr("value"); 
      $("ul#SingleOptionSelector-1-dropdown").css('display', 'none');
      
      //let selectedVariantId = getUrlParameter('variant');
      //console.log("selectedVariantId = " + selectedVariantId);
            
      
  	});
  
  
   function getUrlParameter(sParam) {
     var sPageURL = window.location.search.substring(1),
         sURLVariables = sPageURL.split('&'),
         sParameterName,
         i;

     for (i = 0; i < sURLVariables.length; i++) {
       sParameterName = sURLVariables[i].split('=');

       if (sParameterName[0] === sParam) {
         return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
       }
     }
     return false;
   };

  
  
  
  
  

  
  
  

});